/**
 * Creates a URL for a build hub project page
 * @param urlSegment - The UrlSegment of the build hub project
 * @param path - Optional path segment to append after the buildHubId
 * @returns A properly formatted URL string for the build hub project
 * @example
 * makeBuildHubUrl('123', 'documents') // returns '/app/project/123/documents'
 */
export const makeBuildHubUrl = (urlSegment: string, path?: string): string => {
    // Using a dummy base URL since we only need the pathname
    const baseUrl = new URL('/app/project', 'http://foo');
    const cleanPath = path?.replace(/^\/+|\/+$/g, '');

    // Encode each path segment separately to preserve forward slashes
    const encodedPath = cleanPath
        ?.split('/')
        .map((segment) => encodeURIComponent(segment))
        .join('/');

    baseUrl.pathname = [baseUrl.pathname, urlSegment, encodedPath]
        .filter(Boolean)
        .join('/');
    return baseUrl.pathname;
};
